<template>
  <div id="app">
    <router-view name="header" />
    <router-view name="content" class="app-content" />
    <footer class="my-footer has-text-centered">
      <router-link :to="{ name: 'privacy-policy' }"
        >Ochrana osobných údajov</router-link
      >
      <!-- <cookie-law
        theme="dark-lime"
        buttonText="ok"
        message="Tento web používa súbory cookies.">
      </cookie-law> -->
    </footer>
  </div>
</template>

<script>
export default {}
</script>
